export default __webpack_public_path__ + "static/media/Avatar5.1ffbd8f4.mp3";